// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__gD-xE","ThumbZoom":"ChapterPlayer_ThumbZoom__2GQQh"};